export enum TrainingActionType {
    INTENSIVE = "intensive",
    ALTERNANCE = "alternance",
    AFEST = "afest",
}

export function isTrainingActionType(value: string): value is TrainingActionType {
    return Object.values(TrainingActionType).includes(value as TrainingActionType);
}
